import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useSettingsV3 } from '../hooks/useSettingsV3'

/**
 * ═══ LA V1 RENVOIE VERS LA V2, QUAND LA CONF LE DEMANDE ═══
 *
 * Réglage `FO_MEETING_REDIRECT_TO_V2` (BO → Config FO V2, groupe FO Meeting). Toute page
 * de la V1 part alors vers `event.gayakoa.com/<alias>` (dev : `event.dev`) EN EMPORTANT LE JETON :
 * celui de l'adresse s'il y en a un (lien d'e-mail, bouton du BO), sinon celui de la
 * session (`localStorage.token`). La V2 le lit sur n'importe quelle page (`auth/link.ts`)
 * et le retire de la barre d'adresse : la personne arrive connectée, sans rien retaper.
 *
 * ⚠️ `replace`, pas `href` : la page V1 ne doit pas rester dans l'historique, sinon
 * « Retour » y revient et repart aussitôt.
 *
 * L'adresse est celle du produit, d'après l'hôte de la V1 : `event.dev.gayakoa.com` en dev,
 * `event.gayakoa.com` en production (2026-08-27) ; il n'y a plus de réglage d'adresse.
 */
function v2Base() {
  const { hostname } = window.location
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'http://localhost:4002'
  if (hostname.endsWith('.dev.gayakoa.com') || hostname === 'd1cwsl2gmmbvf6.cloudfront.net') {
    return 'https://event.dev.gayakoa.com'
  }
  return 'https://event.gayakoa.com'
}

const isOn = value => value === true || value === 1 || value === '1' || value === 'true'

export default function RedirectToV2() {
  const { settings } = useSettingsV3()
  const { context } = useParams()
  const location = useLocation()

  useEffect(() => {
    if (!isOn(settings?.FO_MEETING_REDIRECT_TO_V2) || !context) return
    const base = v2Base()

    const search = new URLSearchParams(location.search)
    const token = search.get('token') || localStorage.getItem('token')
    if (token) search.set('token', token)
    const query = search.toString()

    window.location.replace(`${base}/${encodeURIComponent(context)}${query ? `?${query}` : ''}`)
  }, [settings, context, location.search])

  return null
}
